import { render, staticRenderFns } from "./nfUpdateTips.vue?vue&type=template&id=6f3a2c66&scoped=true&"
import script from "./nfUpdateTips.vue?vue&type=script&lang=js&"
export * from "./nfUpdateTips.vue?vue&type=script&lang=js&"
import style0 from "./nfUpdateTips.vue?vue&type=style&index=0&id=6f3a2c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a2c66",
  null
  
)

export default component.exports